var React = require('react');

function Enter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.41667 0H37.5833C41.1217 0 44 2.87833 44 6.41667V37.5833C44 41.1217 41.1217 44 37.5833 44H6.41667C2.87833 44 0 41.1217 0 37.5833V6.41667C0 2.87833 2.87833 0 6.41667 0ZM7.33333 24.75C7.33333 25.256 7.744 25.6667 8.25 25.6667H27.5V30.25C27.5 30.5965 27.6962 30.9137 28.006 31.0695C28.1362 31.1337 28.2773 31.1667 28.4167 31.1667C28.611 31.1667 28.8053 31.1043 28.9667 30.9833L36.3 25.4833C36.531 25.311 36.6667 25.0378 36.6667 24.75C36.6667 24.4622 36.531 24.189 36.3 24.0167L28.9667 18.5167C28.6898 18.3077 28.3158 18.2765 28.0078 18.4305C27.6962 18.5863 27.5 18.9035 27.5 19.25V23.8333H9.16667V13.75C9.16667 13.244 8.756 12.8333 8.25 12.8333C7.744 12.8333 7.33333 13.244 7.33333 13.75V24.75Z"}));
}

Enter.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"#231F20"};

module.exports = Enter;

Enter.default = Enter;
